module.exports = require('./build/timsort.js');